<template>
  <div class="container" ref="ranking">
     <div class="pullup">
       <div :class="`headtip ${type === 'page' ? 'active': ''}`" v-if="list.length>0">
        -&nbsp;名单顺序不分前后&nbsp;-
       </div>
      <!-- <div class="rank-title-wrapper"  v-if="list.length>0">
        <div class="title">姓名/作品</div>
      </div> -->
      <div ref="scroll" :class="`pullup-wrapper ${type=== 'page' ? 'page': ''}`">
        <div class="pullup-content" ref="pullupContent">
          <ul class="pullup-list">
            <li v-for="(item, index) in list" :key="item.artical_id" :class="`rank-${index + 1} ${item.isself === 1? 'self': ''}`">
                <img :src="item.headicon" alt="" class="headicon">
                <div class="article-info">
                  <p class="title">{{item.title}}</p>
                  <div class="user">
                    <span class="name">{{item.name}}</span>
                    <span class="per-info" v-if="+activityStatus === 3">{{formatPeriod(item.period)}}</span>
                  </div>
                </div>
            </li>
          </ul>
          <div class="loading-wrapper">
            <div class="loading" v-show="loading">加载中...</div>
            <div class="no-data tip" v-show="isShowNoData">
              <div>暂无数据</div>
            </div>
            <div class="getmore" @click="handleMore" v-if="type === 'component' && !loading && hasMore">查看更多</div>
            <div class="nomore" v-if="!hasMore && hasRankList">没有更多了~</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import { MapPeriod, ClientHeight } from './const'
import { getUrlParmas } from '@/common/utils/xesFunction'

BScroll.use(Pullup)

export default {
  props: {
    personalArtical: {
      type: Object,
      default() {
        return {}
      }
    },
    province_id: {
      type: String
    },

    isShowSelf: {
      type: Boolean,
      required: false
    },

    type: {
      type: String,
      default: 'component'
    },
    activityStatus: {
      type: [String, Number]
    },
    isLogin: {
      type: Boolean
    }
  },
  data() {
    return {
      isPullUpLoad: false,
      list: [],
      page: 1,
      hasRankList: true,
      periodId: '',
      hasMore: true,
      loading: false,
      isShowClone: true
    }
  },
  computed: {
    isShowNoData() {
      return !this.hasRankList
    }
  },
  async mounted() {
    console.log('mounted')
    this.init()
    this.type === 'page' && window.addEventListener('scroll', this.debounce(this.scrollFn, 100))
  },
  destroyed() {
    // this.bscroll.destroy()
    this.type === 'page' && window.removeEventListener('scroll', this.scrollFn)
  },
  watch: {
    isShowNoData(val) {
      if (val) {
        console.log('disable')
        this.$refs.scroll.classList.add('disabled')
      }
    },
    isLogin(val) {
      if (val) {
        this.isLogin = val
        this.resetScroll()
        this.init()
      }
    }
  },

  methods: {
    formatType(type) {
      const Map = {
        3: 0,
        4: 1
      }
      return Map[type]
    },
    debounce(fn, wait) {
      let timeout = null
      return function() {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    scrollFn() {
      if (document.documentElement.scrollHeight - (window.pageYOffset + window.innerHeight) <= 600) {
        this.requestData()
      }
    },
    async init() {
      await this.requestData(true)
    },
    resetScroll() {
      this.hasRankList = true
      this.hasMore = true
      this.page = 1
      this.isShowClone = true
      this.list.splice(0, this.list.length)
      this.requestData()
    },
    async requestData(isInit) {
      if (!this.hasMore || this.loading) {
        return
      }
      this.loading = true
      const res = await this.$api.rosterRecommend({
        articalType: this.formatType(this.activityStatus), // 0 复选 1决选
        // artical_type: 0,
        page: this.page,
        pageSize: 10
      }).catch(err => {
        console.error(err)
      })
      this.loading = false
      this.page++
      const data = res.data
      if (+res.code === 0 && data) {
        if (data.artical_list && data.artical_list.length) {
          this.list.push(...data.artical_list)
          // 计算高度
          if (this.type === 'page' && isInit) {
            this.$nextTick(() => {
              const { offsetHeight } = this.$refs.ranking
              if (offsetHeight < ClientHeight) {
                this.requestData(isInit)
              }
            })
          }
          if (this.list.length >= data.total) {
            this.hasMore = false
          }

          this.isShowClone = false
        } else {
          this.hasMore = false
          // this.$refs.scroll.classList.add('disabled')
          if (isInit) {
            this.hasRankList = false
          } else {
            this.hasMore = false
          }
        }
      } else {
        if (+res.code === 50000) {
          this.hasRankList = false
          this.hasMore = false
        }
        // this.$toast(res.msg || '获取征文信息失败')
      }
    },
    formatPeriod(index) {
      return `第${MapPeriod[index - 1]}期`
    },
    // 查看更多
    handleMore() {
      this.$xesLogger.clickMsg({
        params: { clickid: '205', elemname: '点击查看更多', activityStatus: this.activityStatus }
      })
      this.$router.push({
        path: this.activityStatus === 3 ? '/fuxuan' : '/juesheng',
        query: {
          ...getUrlParmas(location.href),
          activityStatus: this.activityStatus
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.rank-title-wrapper {
  display: flex;

  .title {
    padding-left: 154px/2;
    text-align: left;
  }

  > div {
    flex: 1;
    margin: 14px 0;
    font-size: 13px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 13px;
    text-align: center;
    color: #999;

    &:nth-child(2) {
      flex: 1.5;
    }
  }
}

.pullup-list {
  > li {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    margin-bottom: 6px;
    font-size: 21px;
    font-weight: bold;
    color: #999;

    &.self {
      position: relative;
      background: #fffaee;
      border: 1px solid #ffdc51;
      border-radius: 16px/2;
      box-shadow: 0 -1px 0 0 #f7f1e2;

      &::after {
        position: absolute;
        bottom: 0;
        left: 8%;
        width: 86%;
        content: ' ';
        border-bottom: 1px solid #f3f3f3;
      }
    }

    > span {
      text-align: center;
    }

    // .article-info-wrapper {
    //   display: flex;
    //   align-items: center;
    //   // flex: 3;
    //   overflow: hidden;
    //   // line-height: 40px;
    //   font-size: 0;
    //   text-align: left;

    .headicon {
      // float: left;
      width: 40px;
      height: 40px;
      margin-right: 12px;
      border-radius: 50%;
    }

    .article-info {
      display: flex;
      flex-direction: column;
      // display: block;
      // width: 144px;
      // padding-top: 3px;
      overflow: hidden;
      line-height: 1.4;
      text-align: left;

      .title {
        // width: 90px;
        // width: 98%;
        // height: 15px;
        overflow: hidden;
        font-size: 15px;
        font-weight: 300;
        font-family: PingFangSC-Semibold, PingFang SC;
        // line-height: 15px;
        white-space: nowrap;
        color: #333;
        text-overflow: ellipsis;
      }

      .user {
        display: flex;
        // width: 98%;
        // height: 18px;
        margin-top: 4px;
        // margin-top: 4px;
        overflow: hidden;
        font-size: 13px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        white-space: nowrap;
        color: #999;
        text-overflow: ellipsis;

        .name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .per-info {
          display: inline-block;
          flex: 0 0 79px/2;
          width: 79px/2;
          height: 32px/2;
          margin-left: 7px/2;
          font-size: 10px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 34px/2;
          text-align: center;
          color: #fe9b42;
          background: #fef5ec;
          border: 1px solid #feac65;
          border-radius: 8px;
        }
      }
    }
    // }

    .popularity {
      flex: 1;
      font-size: 15px;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #e02727;
    }
  }
}

.pullup {
  height: 100%;

  .headtip {
    height: 62px/2;
    font-size: 11px;
    line-height: 62px/2;
    text-align: center;
    color: #999;
  }

  .active {
    background: #f7f1e2;
  }
}

.pullup .pullup-wrapper {
  height: 100%;
  padding: 0 13px;
  overflow: hidden;
}

.pullup-wrapper.page {
  margin-top: 18px;
}

.pullup-wrapper.disabled {
  // pointer-events: none;

  .pullup-content {
    // pointer-events: none;
  }
}

.pullup .pullup-list {
  padding: 0;
}

.pullup .pullup-list-item {
  padding: 10px 0;
  list-style: none;
  border-bottom: 1px solid #ccc;
}

.pullup .pullup-tips {
  padding: 20px;
  text-align: center;
  color: #999;
}

.no-data {
  position: relative;
  height: 150px;
  text-align: center;
  background: url(../../../../assets/images/home/no_data.png) top center no-repeat;
  background-size: 100px 100px;
  pointer-events: none !important;

  > div {
    position: absolute;
    top: 74%;
    width: 100%;
    font-size: 26px/2;
    text-align: center;
    color: #666;
  }
}

.loading-wrapper {
  position: relative;
  // padding: 10px 0 40px;
  .loading {
    height: 30px;
    margin-bottom: 10px;
    line-height: 30px;
    text-align: center;
    color: #999;
  }

  .loading-clone {
    visibility: hidden;
  }

  .tip {
    margin: 30px 0 10px;
    text-align: center;
    color: #999;
  }
}

.getmore {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-bottom: 10px;
  font-size: 10px;
  color: #999;

  &::after {
    display: inline-block;
    width: 24px/2;
    height: 26px/2;
    background: url(../../../../assets/images/home/arrow-right.png) no-repeat;
    background-size: cover;
    content: '';
  }
}

.nomore {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-bottom: 10px;
  font-size: 10px;
  color: #999;
}
</style>
